var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.826,
    height: 10.895,
    viewBox: "0 0 10.826 10.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    transform: "translate(-213.883 -1.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M254.562,36.074v-.017l-.011.017Z",
    transform: "translate(-34.857 -29.377)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M223.909,1.783h-9.226a.791.791,0,0,0-.8.78V11.9a.79.79,0,0,0,.8.78h9.226a.79.79,0,0,0,.8-.78V2.563A.791.791,0,0,0,223.909,1.783Zm-6.744,9.12H215.53V5.983h1.635Zm-.818-5.591h-.011a.934.934,0,1,1,.011,0Zm6.714,5.591h-1.635V8.271c0-.661-.237-1.112-.828-1.112a.9.9,0,0,0-.839.6,1.122,1.122,0,0,0-.054.4V10.9h-1.635s.021-4.458,0-4.919H219.7v.7a1.623,1.623,0,0,1,1.474-.812c1.076,0,1.882.7,1.882,2.214Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a39926e27487f1316dc021558b9988fe.svg";
export { ForwardRef as ReactComponent };